import { render } from "./WithNoSwiper.vue?vue&type=template&id=1187de5c&scoped=true"
import script from "./WithNoSwiper.vue?vue&type=script&lang=js"
export * from "./WithNoSwiper.vue?vue&type=script&lang=js"

import "./WithNoSwiper.vue?vue&type=style&index=0&id=1187de5c&scoped=true&lang=css"
import "./WithNoSwiper.vue?vue&type=style&index=1&id=1187de5c&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1187de5c"]])

export default __exports__